import React from "react";
import TitleWord from "../../../utils/TitleWord";
import { useTranslation } from "react-i18next";

export default function StepTitle(props: any) {
  const {t} = useTranslation();
  return (
    <>
      <div className="titleHeader flex justify-between items-center">
        {props.stepTitle && (
          <h4
            // className={`${
            //   props.err
            //     ? "rounded-[4px] border border-[#F00] bg-[#FFE9E9] text-[#FF0000] p-2 inline-block"
            //     : ""
            // } textMd font-bold mb-2`}
            className={` font-normal  font-splekta text-xl `}
          >
            {/* {props.err && <i className="fa fa-exclamation-circle mr-1"></i>} */}
            {TitleWord(props.stepTitle)}{" "}
            {props.required && <span className="">*</span>}
          </h4>
        )}

        {(props?.required) &&
          <p
            className={`textMd font-medium primary rounded-3xl px-2
              ${props.success? "text-[#0E8345] bg-[#0E83450D] "
              : props.err? "text-[#F01919] bg-[#F019190D] ": "bg-[#E8E8E8] text-black"
              } `}
          >
            {props.success
              ?<i className="fa fa-check text-[#0E8345]"></i>:null}
            {props.err
              ?<i className="fa fa-exclamation-circle text-[#F01919]"></i>:null}
            {t("Home.required")}
          </p>
        }
      </div>
    </>
  );
}
